<p-toast></p-toast>
<div class="w-full flex flex-column gap-4">

  <!-- Header -->
  <div class="w-full flex align-items-center justify-content-between">
    <div class="flex align-items-center gap-2">
      <div class="flex-shrink-0 border-circle flex align-items-center justify-content-center"
        style="width:36px;height:36px;background:#5B4BD9;">
        <i class="pi pi-building" style="color:#fff;font-size:1rem;"></i>
      </div>
      <h2 class="font-semibold text-xl m-0" style="color:#12263F;">My Colleges</h2>
    </div>
    <span class="text-sm font-medium px-3 py-1 border-round-3xl"
      style="background:#EEF2FA;color:#4B6088;">
      {{institutes.length}} college{{institutes.length !== 1 ? 's' : ''}}
    </span>
  </div>

  <!-- Loading skeleton -->
  <div *ngIf="isLoading" class="flex flex-column gap-3">
    <div *ngFor="let _ of [1,2,3]"
      class="w-full border-round-lg p-4 animate-pulse"
      style="height:88px;background:#F3F5F9;">
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && institutes.length === 0"
    class="w-full flex flex-column align-items-center justify-content-center gap-3 p-6 border-round-xl"
    style="background:#F9FAFB;border:2px dashed #D0D7E3;">
    <i class="pi pi-building text-4xl" style="color:#B1C2D9;"></i>
    <p class="text-sm font-medium" style="color:#8A99B0;">No colleges added to this student's list yet.</p>
  </div>

  <!-- Institutes list -->
  <div *ngIf="!isLoading && institutes.length > 0" class="flex flex-column gap-3">
    <div *ngFor="let institute of institutes"
      class="w-full flex flex-column sm:flex-row align-items-start sm:align-items-center justify-content-between gap-3 border-1 border-round-xl p-4 bg-white college-row">

      <!-- Left: Logo + Name + Location -->
      <div class="flex align-items-center gap-3 flex-1 min-w-0">
        <div class="w-4rem h-4rem overflow-hidden border-circle flex-shrink-0 border-1"
          style="border-color:#E3EBF6;">
          <img [src]="institute.logo || '../../../../assets/images/logo-placeholder.png'"
            alt="{{institute.instituteName}}"
            style="width:100%;height:100%;object-fit:cover;">
        </div>
        <div class="flex flex-column gap-1 min-w-0">
          <b class="font-semibold text-base white-space-nowrap overflow-hidden text-overflow-ellipsis"
            style="color:#12263F;max-width:280px;">{{institute.instituteName}}</b>
          <span class="text-sm" style="color:#6B7EA0;">
            {{institute.city}}, {{institute.country}}
          </span>
        </div>
      </div>

      <!-- Middle: Deadlines -->
      <div class="flex flex-column gap-2 flex-shrink-0" style="min-width:220px;">
        <!-- Official deadline -->
        <div class="flex align-items-center gap-2">
          <span class="text-xs font-medium px-2 py-1 border-round-lg"
            style="background:#EEF2FA;color:#4B6088;white-space:nowrap;">
            Official
          </span>
          <span class="text-sm" style="color:#4B4E62;">
            {{institute.applicationDeadlineRegularDecision | date:'dd MMM yyyy'}}
          </span>
          <span *ngIf="institute.applicationDeadlineRegularDecision"
            class="text-xs font-bold px-2 py-1 border-round-lg"
            [style.background]="(calculateDaysLeft(institute.applicationDeadlineRegularDecision) ?? 0) <= 14 ? '#FFF0F0' : '#F0FFF4'"
            [style.color]="(calculateDaysLeft(institute.applicationDeadlineRegularDecision) ?? 0) <= 14 ? '#C94040' : '#2D7B4D'">
            {{calculateDaysLeft(institute.applicationDeadlineRegularDecision)}} days
          </span>
        </div>

        <div *ngIf="institute.mentorDeadline" class="flex align-items-center gap-2">
          <span class="text-sm font-medium" style="color:#5B4BD9;">
            {{institute.mentorDeadline | date:'dd MMM yyyy'}}
          </span>
          <span class="text-xs font-bold px-2 py-1 border-round-lg"
            [style.background]="(calculateDaysLeft(institute.mentorDeadline) ?? 0) <= 14 ? '#FFF0F0' : '#F0EEFF'"
            [style.color]="(calculateDaysLeft(institute.mentorDeadline) ?? 0) <= 14 ? '#C94040' : '#5B4BD9'">
            {{calculateDaysLeft(institute.mentorDeadline)}} days
          </span>
        </div>
        <div *ngIf="!institute.mentorDeadline">
          <span class="text-xs" style="color:#A0AEC0;">No mentor deadline set</span>
        </div>
      </div>

      <div class="flex align-items-center gap-2 flex-shrink-0">
        <p-button icon="pi pi-pencil" tooltipPosition="top" 
          [pTooltip]="institute.mentorDeadline ? 'Update mentor deadline' : 'Set a custom mentor deadline'"
          styleClass="edit_pencil_btn" (onClick)="openDeadlineDialog(institute)" />
        <p-button icon="pi pi-trash" tooltipPosition="top"
          pTooltip="Remove college from student's list"
          styleClass="p-button-danger p-button-text p-button-sm"
          (onClick)="deleteCollege(institute)" />
      </div>
    </div>
  </div>

</div>

<!-- Deadline Dialog -->
<app-mentor-deadline-dialog
  *ngIf="selectedInstitute"
  [studentId]="studentId"
  [institute]="selectedInstitute"
  [currentDeadline]="selectedInstitute.mentorDeadline"
  [(visible)]="deadlineDialogVisible"
  (deadlineSaved)="onDeadlineSaved($event)">
</app-mentor-deadline-dialog>
